var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_2248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_2248",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.001 0.439941H0.000976562V50.4399H50.001V0.439941Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_2248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2223 24.0619L26.3782 38.2178C28.9418 40.7814 28.9418 44.9764 26.3782 47.5399C23.8147 50.1035 19.6197 50.1035 17.0561 47.5399L2.90021 33.3841C0.336649 30.8206 0.336649 26.6256 2.90021 24.062C5.46377 21.4984 9.65878 21.4983 12.2223 24.0619Z",
    stroke: "#003588",
    strokeWidth: 1.95312,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9553 31.4849L10.3237 40.1165",
    stroke: "#003588",
    strokeWidth: 1.95312,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1056 17.0387C38.7941 11.3502 41.4293 4.76237 38.9913 2.32445C36.5534 -0.113473 29.9656 2.52167 24.2771 8.2102C18.5886 13.8987 15.9534 20.4865 18.3913 22.9245C20.8293 25.3624 27.4171 22.7272 33.1056 17.0387Z",
    stroke: "#003588",
    strokeWidth: 1.95312,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6514 8.58447L32.7318 16.6649",
    stroke: "#003588",
    strokeWidth: 1.95312,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6005 40.8911C44.8052 40.8911 49.0243 36.6719 49.0243 31.4673C49.0243 26.2627 44.8052 22.0435 39.6005 22.0435C34.3959 22.0435 30.1768 26.2627 30.1768 31.4673C30.1768 36.6719 34.3959 40.8911 39.6005 40.8911Z",
    stroke: "#003588",
    strokeWidth: 1.95312,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0259 23.7856L47.2828 36.0425",
    stroke: "#003588",
    strokeWidth: 1.95312,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9185 26.8931L44.1753 39.15",
    stroke: "#003588",
    strokeWidth: 1.95312,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_2248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.439941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialized);
export default __webpack_public_path__ + "static/media/specialized.0b0ef457e8d54f8f7cb65adb2cef1e9a.svg";
export { ForwardRef as ReactComponent };